import { Button as ButtonComponent } from 'components/Button';
import styled from 'theme';

export const ContactInfo = styled.div`
  margin: 80px 1.5rem;

  > p {
    margin-top: 0;
  }
`;

export const MessengerContainer = styled.div`
  margin-left: 1.5rem;
  margin-right: 1.5rem;
  margin-bottom: 80px;

  .dimelo-chat-wrapper {
    width: 100% !important;
  }

  .dimelo-chat-wrapper.dimelo-chat-embedded:not(.dimelo-chat-condensed) {
    .dimelo-chat-embedded-header {
      display: none;
    }
  }

  .dimelo-chat-wrapper.dimelo-chat-embedded {
    .dimelo-chat-container {
      border-radius: 6px;
    }

    .dimelo-chat-timestamp p, .dimelo-chat-welcome-message p {
        background: transparent;
    }

    .dimelo-chat-window, .dimelo-chat-body {
      border-radius: 6px;
    }

    .dimelo-chat-header {
      background-color: ${(p) => p.theme.colors.white};

      color: ${(p) => p.theme.colors.black};

      .dimelo-chat-control {
        background-color: ${(p) => p.theme.colors.primary};
      }
    }

    .dimelo-chat-threads-container .dimelo-chat-threads-listing {
      margin: 16px 24px;

      .dimelo-chat-thread {
        margin-top 16px;
        border-radius: 6px;
        background-color: #D7DADC;

        &.dimelo-chat-thread-selected {
          background-color: #F1F2F3;
        }

        .dimelo-chat-thread-element {
          border-bottom: none;
        }
      }
    }

    .dimelo-chat-timestamp > p {
      background: transparent;
      color: ${(p) => p.theme.colors.gray900};
    }

    .dimelo-chat-conversation-frame {
      background-color: ${(p) => p.theme.colors.grayL10}
    }

    .dimelo-chat-message-someone-else > .dimelo-chat-message-body {
      background-color: ${(p) => p.theme.colors.primary};
      color: ${(p) => p.theme.colors.black};

      border-top-right-radius: 5px;
    }

    .dimelo-chat-message-self > .dimelo-chat-message-body {
      background-color: ${(p) => p.theme.colors.white};
      color: #000;

      border-top-left-radius: 5px;
    }

    .dimelo-chat-input-zone {
      background-color: ${(p) => p.theme.colors.white};
    }

    .dimelo-chat-textarea-zone {
      margin: 16px;
    }
  }
`;

export const Button = styled(ButtonComponent)`
  display: inline-block;

  width: auto;
  height: auto;
  padding: 12px 16px;

  white-space: initial;
  text-align: center;
`;

export const EmbeddedChat = styled.div`
  height: 80vh;
`;
